import * as React from 'react';
import { EPageType } from '../shared/types/page';

let CareerContainer: React.ComponentType | null = null;
let CareerVacanciesContainer: React.ComponentType | null = null;
let CareerVacancyContainer: React.ComponentType | null = null;
let MarketingPage: React.ComponentType | null = null;
let AnalyticsPage: React.ComponentType | null = null;
let TechnologiesPage: React.ComponentType | null = null;
let ProductPage: React.ComponentType | null = null;
let BackofficePage: React.ComponentType | null = null;
let DanilPage: React.ComponentType | null = null;
let danilLoading: Promise<void> | null = null;
let NikitaPage: React.ComponentType | null = null;
let nikitaLoading: Promise<void> | null = null;
let NataliaPage: React.ComponentType | null = null;
let nataliaLoading: Promise<void> | null = null;
let DimaPage: React.ComponentType | null = null;
let dimaLoading: Promise<void> | null = null;
let VeronicaPage: React.ComponentType | null = null;
let veronicaLoading: Promise<void> | null = null;
let careerLoading: Promise<void> | null = null;
let marketingLoading: Promise<void> | null = null;
let analyticsLoading: Promise<void> | null = null;
let technologiesLoading: Promise<void> | null = null;
let productLoading: Promise<void> | null = null;
let backofficeLoading: Promise<void> | null = null;

export const loadCareerPage = (pageType?: EPageType): Promise<void> => {
  if (pageType === EPageType.CareerTeamMarketing) {
    if (!marketingLoading) {
      marketingLoading = import(
        /* webpackChunkName: "marketing" */ '../shared/containers/CareerTeamMarketing/MarketingPage'
      ).then(marketing => {
        MarketingPage = marketing.MarketingPage;
      });
    }

    return marketingLoading;
  }

  if (pageType === EPageType.CareerTeamAnalytics) {
    if (!analyticsLoading) {
      analyticsLoading = import(
        /* webpackChunkName: "analytics" */ '../shared/containers/CareerTeamAnalytics/AnalyticsPage'
      ).then(analytics => {
        AnalyticsPage = analytics.AnalyticsPage;
      });
    }

    return analyticsLoading;
  }

  if (pageType === EPageType.CareerTeamTechnologies) {
    if (!technologiesLoading) {
      technologiesLoading = import(
        /* webpackChunkName: "technologies" */ '../shared/containers/CareerTeamTechnologies/TechnologiesPage'
      ).then(technologies => {
        TechnologiesPage = technologies.TechnologiesPage;
      });
    }

    return technologiesLoading;
  }

  if (pageType === EPageType.CareerTeamProduct) {
    if (!productLoading) {
      productLoading = import(
        /* webpackChunkName: "product" */ '../shared/containers/CareerTeamProduct/ProductPage'
      ).then(product => {
        ProductPage = product.ProductPage;
      });
    }

    return productLoading;
  }

  if (pageType === EPageType.CareerTeamBackoffice) {
    if (!backofficeLoading) {
      backofficeLoading = import(
        /* webpackChunkName: "backoffice" */ '../shared/containers/CareerTeamBackoffice/BackofficePage'
      ).then(backoffice => {
        BackofficePage = backoffice.BackofficePage;
      });
    }

    return backofficeLoading;
  }

  if (pageType === EPageType.CareerPersonDanil) {
    if (!danilLoading) {
      danilLoading = import(/* webpackChunkName: "person-danil" */ '../shared/containers/CareerPerson/DanilPage').then(
        page => {
          DanilPage = page.DanilPage;
        },
      );
    }

    return danilLoading;
  }
  if (pageType === EPageType.CareerPersonNikita) {
    if (!nikitaLoading) {
      nikitaLoading = import(
        /* webpackChunkName: "person-nikita" */ '../shared/containers/CareerPerson/NikitaPage'
      ).then(page => {
        NikitaPage = page.NikitaPage;
      });
    }

    return nikitaLoading;
  }
  if (pageType === EPageType.CareerPersonNatalia) {
    if (!nataliaLoading) {
      nataliaLoading = import(
        /* webpackChunkName: "person-natalia" */ '../shared/containers/CareerPerson/NataliaPage'
      ).then(page => {
        NataliaPage = page.NataliaPage;
      });
    }

    return nataliaLoading;
  }
  if (pageType === EPageType.CareerPersonDima) {
    if (!dimaLoading) {
      dimaLoading = import(/* webpackChunkName: "person-dima" */ '../shared/containers/CareerPerson/DimaPage').then(
        page => {
          DimaPage = page.DimaPage;
        },
      );
    }

    return dimaLoading;
  }
  if (pageType === EPageType.CareerPersonVeronica) {
    if (!veronicaLoading) {
      veronicaLoading = import(
        /* webpackChunkName: "person-veronica" */ '../shared/containers/CareerPerson/VeronicaPage'
      ).then(page => {
        VeronicaPage = page.VeronicaPage;
      });
    }

    return veronicaLoading;
  }
  if (!careerLoading) {
    careerLoading = Promise.all([
      import(/* webpackChunkName: "career" */ '../shared/containers/Career/CareerContainer'),
      import(/* webpackChunkName: "career" */ '../shared/containers/CareerVacancies/CareerVacanciesContainer'),
      import(/* webpackChunkName: "career" */ '../shared/containers/CareerVacancy/CareerVacancyContainer'),
    ]).then(([career, vacancies, vacancy]) => {
      CareerContainer = career.CareerContainer;
      CareerVacanciesContainer = vacancies.CareerVacanciesContainer;
      CareerVacancyContainer = vacancy.CareerVacancyContainer;
    });
  }

  return careerLoading;
};

export const CareerPage: React.FC = () => {
  if (!CareerContainer) {
    throw new Error('Career page must be loaded before hydration');
  }

  return <CareerContainer />;
};

export const CareerVacanciesPage: React.FC = () => {
  if (!CareerVacanciesContainer) {
    throw new Error('Career vacancies page must be loaded before hydration');
  }

  return <CareerVacanciesContainer />;
};

export const CareerVacancyPage: React.FC = () => {
  if (!CareerVacancyContainer) {
    throw new Error('Career vacancy page must be loaded before hydration');
  }

  return <CareerVacancyContainer />;
};

export const CareerTeamMarketingPage: React.FC = () => {
  if (!MarketingPage) {
    throw new Error('Career marketing page must be loaded before hydration');
  }

  return <MarketingPage />;
};

export const CareerTeamAnalyticsPage: React.FC = () => {
  if (!AnalyticsPage) {
    throw new Error('Career analytics page must be loaded before hydration');
  }

  return <AnalyticsPage />;
};

export const CareerTeamTechnologiesPage: React.FC = () => {
  if (!TechnologiesPage) {
    throw new Error('Career technologies page must be loaded before hydration');
  }

  return <TechnologiesPage />;
};

export const CareerTeamProductPage: React.FC = () => {
  if (!ProductPage) {
    throw new Error('Career product page must be loaded before hydration');
  }

  return <ProductPage />;
};

export const CareerTeamBackofficePage: React.FC = () => {
  if (!BackofficePage) {
    throw new Error('Career backoffice page must be loaded before hydration');
  }

  return <BackofficePage />;
};

export const CareerPersonDanilPage: React.FC = () => {
  if (!DanilPage) {
    throw new Error('Person danil page must be loaded before hydration');
  }

  return <DanilPage />;
};

export const CareerPersonNikitaPage: React.FC = () => {
  if (!NikitaPage) {
    throw new Error('Person nikita page must be loaded before hydration');
  }

  return <NikitaPage />;
};

export const CareerPersonNataliaPage: React.FC = () => {
  if (!NataliaPage) {
    throw new Error('Person natalia page must be loaded before hydration');
  }

  return <NataliaPage />;
};

export const CareerPersonDimaPage: React.FC = () => {
  if (!DimaPage) {
    throw new Error('Person dima page must be loaded before hydration');
  }

  return <DimaPage />;
};

export const CareerPersonVeronicaPage: React.FC = () => {
  if (!VeronicaPage) {
    throw new Error('Person veronica page must be loaded before hydration');
  }

  return <VeronicaPage />;
};
